export default __webpack_public_path__ + "static/media/about-grid-01.c6213cc3.jpg";